// 上传文件通用接口
var remove_common = function(s_remove_url){
      
    let url = "/api/remove_file/"
    let d_data = {'s_url': s_remove_url}
    let res = this.$axios.post(url, d_data)
    console.log(res)
    return res
  }

export default remove_common



